<template>
  <div
    v-if="bestPrice?.price && !withoutPrice"
    :class="{
      'price-savings-fi': true,
      'price-savings-fi--is-mobile': isMobile,
      'price-savings-fi--stroke-price-absolute': strokePriceAbsolute,
      [`price-savings-fi--theme-${theme}`]: theme,
    }"
    data-test="price-savings"
  >
    <price-savings-in-percent-fi
      v-if="!hideSavingsInPercent && savingsInformation"
      class="price-savings-fi__price-savings-in-percent"
      :best-price="bestPrice"
    />

    <div
      :class="{
        'price-savings-fi__price': true,
        'price-savings-fi__price--stroke': savingsInformation,
      }"
      data-test="price-savings-price"
    >
      <div
        v-if="useEco"
        class="price-savings-fi__eco-wrapper"
      >
        <div class="price-savings-fi__eco-label">
          {{ $dict.get('checkout.Cart.Sum') }}
        </div>
        <span
          v-if="savingsInformation"
          class="price-savings-fi__price-stroke"
          data-test="price-savings-price-stroke"
        >
          {{ savingsInformation.totalStrokePriceValueFormatted }}
        </span>
        <div class="price-savings-fi__eco-price">
          {{ bestPrice.price.totalValueFormatted }}
        </div>
      </div>
      <template v-else>
        <template v-if="showTotalPicePrefix">
          {{ `${$dict.get('product-List.Table.Total')} ${bestPrice.price.totalValueFormatted}` }}
        </template>
        <template v-else>
          {{ bestPrice.price.totalValueFormatted }}
        </template>
        <span
          v-if="savingsInformation"
          class="price-savings-fi__price-stroke"
        >
          {{ savingsInformation.totalStrokePriceValueFormatted }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import PriceSavingsInPercentFi from 'atoms/price-savings-in-percent-fi/PriceSavingsInPercentFi';

export default {
  name: 'PriceSavingsFi',
  components: {
    PriceSavingsInPercentFi,
  },
  props: {
    bestPrice: {
      type: Object,
      default: () => ({}),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
    hideSavingsInPercent: {
      type: Boolean,
      default: false,
    },
    showTotalPicePrefix: {
      type: Boolean,
      default: false,
    },
    strokePriceAbsolute: {
      type: Boolean,
      default: false,
    },
    useEco: Boolean,
  },
  computed: {
    savingsInformation() {
      return this.bestPrice?.price?.savingsInformation;
    },
    withoutPrice() {
      return this.$fischer.shop.hasPurchasePermissionWithoutPrices();
    },
  },
};
</script>

<style scoped lang="scss">
@import './price-savings-fi';
</style>
